module.exports = __webpack_public_path__ + "static/img/activityECode.066e9d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/activity/activityECode.png
// module id = bY/m
// module chunks = 1